import { Box, Stack, Tooltip, Typography } from '@dtx-company/design-system/src'
import { FC, ReactElement, ReactNode } from 'react'
import { questionMarkBlue } from '@app/code/src/assets'
import Image from 'next/image'

interface TitleProps {
  title: string
  icon?: ReactNode
  tooltip?: string
}

export const FormTitle: FC<TitleProps> = ({ title, icon, tooltip }: TitleProps) => {
  return (
    <Stack direction="row" gap="8px">
      {icon}
      <Typography variant="h3">{title}</Typography>
      {tooltip && tooltip.length > 0 && (
        <Tooltip id="embedded-media-types" title={tooltip}>
          <Image src={questionMarkBlue} alt="" width={20} height={20} />
        </Tooltip>
      )}
    </Stack>
  )
}

export const PreviewTitle = (): ReactElement => (
  <Box sx={{ marginBottom: 1 }}>
    <Typography color="primary.black" variant="h4">
      Preview
    </Typography>
  </Box>
)
